/* eslint-disable react/prop-types */
import { Icon, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import dayjs from "dayjs";
import { makeNiceText } from "utils/formatters";

const getRows = (data) => {
  const now = dayjs();
  const rows = [];
  if (data) {
    data.forEach((item) => {
      rows.push({
        // hora: (
        //   <SoftBox>
        //     <SoftTypography verticalAlign="text-top" variant="h4">
        //       {dayjs(item.createdAt).format("HH:mm")}
        //     </SoftTypography>
        //   </SoftBox>
        // ),
        mesa: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="h4" fontWeight="medium">
              {item?.mesa ? item?.mesa : ""}
            </SoftTypography>
          </SoftBox>
        ),
        pedidoNum: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="h4" fontWeight="medium">
              {item?.idPedido ? item?.idPedido : ""}
            </SoftTypography>
          </SoftBox>
        ),
        producto: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="h4" fontWeight="bold" color="dark">
              {item?.producto ? makeNiceText(item?.producto.nombre) : "Sin datos"}
            </SoftTypography>
          </SoftBox>
        ),
        cantidad: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="h4">
              {item?.cantidad ? item?.cantidad : "Sin datos"}
            </SoftTypography>
          </SoftBox>
        ),
        // ingredientes: (
        //   <SoftBox>
        //     <SoftTypography
        //       verticalAlign="text-top"
        //       variant="h4"
        //
        //       fontWeight="medium"
        //     >
        //       {item?.ingredientesQuitados?.length > 0
        //         ? item?.ingredientesQuitados
        //             .map((ingrediente) => makeNiceText(ingrediente.nombre))
        //             .join(", ")
        //         : "-"}
        //     </SoftTypography>
        //   </SoftBox>
        // ),
        comentario: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="h4" fontWeight="medium">
              {item?.comentario ? item?.comentario : "-"}
            </SoftTypography>
          </SoftBox>
        ),
        // transcurrido: (
        //   <SoftBox>
        //     <SoftTypography verticalAlign="text-top" variant="h4" fontWeight="medium">
        //       {now.diff(item?.createdAt, "minute")} min
        //     </SoftTypography>
        //   </SoftBox>
        // ),
        // accion: (
        //   <SoftBox mr={2} display="flex" flexDirection="row">
        //     <Tooltip title="Borrar" placement="top">
        //       <Icon
        //         fontSize="small"
        //         sx={{
        //           cursor: "pointer",
        //         }}
        //         onClick={() => {
        //           console.log(item);
        //         }}
        //       >
        //         cancel
        //       </Icon>
        //     </Tooltip>
        //   </SoftBox>
        // ),
        // color:
        //   now.diff(item?.createdAt, "minute") > 45
        //     ? "#fadbd8"
        //     : now.diff(item?.createdAt, "minute") > 25
        //     ? "#fcf3cf"
        //     : null,
        hasBorder: true,
      });
    });
  }

  return rows;
};

const columns = [
  // {
  //   name: "hora",
  //   desc: " ",
  //   align: "left",
  //   width: "1%",
  //   noOrder: true,
  // },
  { name: "mesa", desc: "Mesa", align: "center", noOrder: true },
  { name: "pedidoNum", desc: "N° pedido", align: "center", noOrder: true },
  { name: "producto", desc: "Descripción", align: "left" },
  { name: "cantidad", desc: "Cantidad", align: "center", noOrder: true },
  // { name: "ingredientes", desc: "SIN", align: "left", noOrder: true },
  { name: "comentario", desc: "Observaciones", align: "left", noOrder: true },
  // { name: "transcurrido", desc: "Transcurrido", align: "center", noOrder: true },
  // { name: "accion", desc: " ", align: "center", width: "1%", noOrder: true },
];

export default { columns, getRows };
